import React, { useEffect, useState } from 'react';
import { Card, Select, Space, Typography, Alert, Empty, Grid } from 'antd';
import { MedicineBoxOutlined } from '@ant-design/icons';
import SaludSatPanel from '../../../components/Common/SaludSatPanel';

const { Title } = Typography;
const { Option } = Select;
const { useBreakpoint } = Grid;

/**
 * Salud SAT en el perfil del contribuyente: SOLO descarga.
 *
 * `permitirCarga={false}` no es una comprobación de permisos —esa la hace el
 * servidor— sino la decisión de que este lugar no carga. Cargar es un acto del
 * panel fiscal, y aquí no debe aparecer el control ni siquiera si quien mira es
 * un Admin.
 *
 * Lleva su propio selector de empresa en vez de compartir el de las otras
 * pestañas: elegir empresa aquí no tiene por qué mover lo que el usuario estaba
 * viendo en Certificados o Impuestos.
 */
const SaludSatTab = ({ companies = [] }) => {
  const screens = useBreakpoint();
  const [empresa, setEmpresa] = useState(null);

  useEffect(() => {
    // Con una sola empresa no hay nada que elegir: se abre en ella.
    if (!empresa && companies.length > 0) {
      setEmpresa(companies[0]);
    }
  }, [companies, empresa]);

  return (
    <Card>
      <div style={{ marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0, marginBottom: 16 }}>
          <MedicineBoxOutlined /> Salud SAT
        </Title>

        <Space
          direction={screens.xs ? 'vertical' : 'horizontal'}
          style={{ marginBottom: 16, width: screens.xs ? '100%' : 'auto' }}
        >
          <Select
            placeholder="Selecciona una empresa"
            style={{ width: screens.xs ? '100%' : 400 }}
            value={empresa?.id}
            onChange={(id) => setEmpresa(companies.find((c) => c.id === id) || null)}
          >
            {companies.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.tax_name} - {c.tax_id}
              </Option>
            ))}
          </Select>
        </Space>
      </div>

      <Alert
        type="info"
        showIcon
        style={{ marginBottom: 16 }}
        message="Tus documentos ante el SAT"
        description="La constancia de situación fiscal y la opinión de cumplimiento describen el estado de tu RFC, no un periodo. Los carga tu gestor fiscal; aquí los descargas cuando los necesites."
      />

      {empresa ? (
        <SaludSatPanel empresa={empresa} permitirCarga={false} />
      ) : (
        <Empty description="Registra una empresa para ver sus documentos del SAT" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Card>
  );
};

export default SaludSatTab;
